import React from 'react';

export default function TermsOfServicePage() {
  return (
    <div className="page-container terms-page">
      <h1>Terms of Service</h1>

      <p>
        By accessing or using this platform, you agree to comply with the
        following terms and conditions.
      </p>

      <ul>
        <li>
          Use the platform only for lawful purposes when browsing or interacting
          with listings for cafés, restaurants, bars, clubs, and hotels.
        </li>

        <li>
          Do not submit false information, spam, or misleading reviews when
          contributing content to the platform.
        </li>

        <li>
          If you create an account, you are responsible for maintaining the
          confidentiality of your login credentials.
        </li>

        <li>
          Businesses listed on the platform are responsible for the accuracy of
          their information, including opening hours, pricing, and services.
        </li>

        <li>
          We may modify, update, or remove listings, content, or features of the
          platform at any time without prior notice.
        </li>

        <li>
          We are not responsible for experiences, services, or transactions that
          occur between users and listed venues.
        </li>
      </ul>

      <p>
        By continuing to use the platform, you acknowledge that you have read
        and agree to these Terms of Service.
      </p>
    </div>
  );
}